var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.646 3.646a.5.5 0 01.708 0l8 8a.5.5 0 010 .708l-8 8a.5.5 0 01-.708-.708L15.293 12 7.646 4.354a.5.5 0 010-.708z",
    fill: "#E92070"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjY0NjQ1IDMuNjQ2NDVDNy44NDE3MSAzLjQ1MTE4IDguMTU4MjkgMy40NTExOCA4LjM1MzU1IDMuNjQ2NDVMMTYuMzUzNiAxMS42NDY0QzE2LjU0ODggMTEuODQxNyAxNi41NDg4IDEyLjE1ODMgMTYuMzUzNiAxMi4zNTM2TDguMzUzNTUgMjAuMzUzNkM4LjE1ODI5IDIwLjU0ODggNy44NDE3MSAyMC41NDg4IDcuNjQ2NDUgMjAuMzUzNkM3LjQ1MTE4IDIwLjE1ODMgNy40NTExOCAxOS44NDE3IDcuNjQ2NDUgMTkuNjQ2NEwxNS4yOTI5IDEyTDcuNjQ2NDUgNC4zNTM1NUM3LjQ1MTE4IDQuMTU4MjkgNy40NTExOCAzLjg0MTcxIDcuNjQ2NDUgMy42NDY0NVoiIGZpbGw9IiNFOTIwNzAiLz4KPC9zdmc+Cg==";
export { SvgChevronDer as ReactComponent };